






































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

import Close from "../resources/close.vue";
import CheckOn from "../resources/checkOn.vue";

@Component({
  components: {
      Close,
      CheckOn
  }
})
export default class TermsOfService extends Vue {
    isCheck = false;

    private disagree(){
        // history.back();
        this.$emit("doCommand", "returnPage", null);
        // this.$router.push("/SignIn");
    }

    private agree(){
        this.$emit("doCommand", "agree", null);
    }

    private returnPage(){
        this.$emit("doCommand", "returnPage", null);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background : this.$store.getters.userConfigColors.backgroundColor
        };
        return style;
    }
    private get userConfigButtonColor(){
        var style = {
            background : this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderColor(){
        var style = {
            border : "solid 1px " + this.userConfigColor
        };
        return style;
    }
}
